import {
  ApplicationConfig,
  provideAppInitializer,
  inject,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { localeInterceptor } from '@core/interceptors/locale.interceptor';
import { IconRegistryService } from '@core/services/icon-registry.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    // Order matters: the auth interceptor refreshes tokens and owns 401s, so it
    // has to run before the error interceptor turns failures into toasts.
    provideHttpClient(withInterceptors([authInterceptor, localeInterceptor, errorInterceptor])),
    // `mat-datepicker` needs a date adapter; the native one is enough for a
    // single date field and adds no dependency.
    provideNativeDateAdapter(),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    // Without this every <mat-icon> renders its ligature name as literal text
    // ("mail", "visibility"), which also inflates the layout it sits in.
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-outlined' } },
    // Registers the `skiss:` SVG namespace for the domain icon set.
    provideAppInitializer(() => inject(IconRegistryService).register()),
  ],
};
